import { supabase } from './supabase.js';

/**
 * @param {string} userId
 * @returns {Promise<{ ids: string[], error: string|null }>}
 */
export async function fetchWishlistListingIds(userId) {
  if (!userId) return { ids: [], error: null };
  const { data, error } = await supabase.from('wishlists').select('listing_id').eq('user_id', userId).limit(500);
  if (error) {
    console.error('[wishlistsService] fetchWishlistListingIds:', error.message);
    return { ids: [], error: error.message };
  }
  const ids = (data ?? []).map(r => r.listing_id).filter(Boolean);
  return { ids, error: null };
}

/**
 * @param {string} userId
 * @param {string} listingId
 */
export async function addWishlistListing(userId, listingId) {
  if (!userId || !listingId) return { error: 'missing_params' };
  const { error } = await supabase.from('wishlists').insert({ user_id: userId, listing_id: listingId });
  if (error && !String(error.message || '').includes('duplicate') && error.code !== '23505') {
    console.error('[wishlistsService] addWishlistListing:', error.message);
    return { error: error.message };
  }
  return { error: null };
}

/**
 * @param {string} userId
 * @param {string} listingId
 */
export async function removeWishlistListing(userId, listingId) {
  if (!userId || !listingId) return { error: 'missing_params' };
  const { error } = await supabase
    .from('wishlists')
    .delete()
    .eq('user_id', userId)
    .eq('listing_id', listingId);
  if (error) {
    console.error('[wishlistsService] removeWishlistListing:', error.message);
    return { error: error.message };
  }
  return { error: null };
}

/**
 * Fusiona favoritos locales (guest) con la cuenta y devuelve el mapa `{ [listingId]: true }`.
 * @param {string} userId
 * @param {string[]} guestListingIds
 */
export async function mergeGuestWishlistIntoAccount(userId, guestListingIds) {
  const { ids: serverIds, error } = await fetchWishlistListingIds(userId);
  if (error) return { likes: {}, error };

  const set = new Set(serverIds);
  const guest = (guestListingIds || []).filter(Boolean);
  for (const id of guest) {
    if (!set.has(id)) {
      const { error: e2 } = await addWishlistListing(userId, id);
      if (!e2) set.add(id);
    }
  }

  const likes = {};
  for (const id of set) likes[id] = true;
  return { likes, error: null };
}
